import {
   PrescriptionP1HistoryDailyGroup,
   PrescriptionP1HistoryPrescriptionStatus,
} from '@dreryk/egabinet-prescription-frontend-api';

import {
   AlertCircleIcon,
   CheckIcon,
   ClockIcon,
   colorsMatrix,
   createDynamicColumnsWidth,
   TableKeyExtractor,
} from '@dreryk/react-components';

export type P1PrescriptionHistoryColumnsWidth = ReturnType<typeof createP1PrescriptionHistoryColumnsWidth>;

type IconComponent = () => JSX.Element;

const p1PrescriptionStatusColorMap: Record<PrescriptionP1HistoryPrescriptionStatus, string> = {
   REALIZED: colorsMatrix.green.basic,
   PARTIALLY_COMPLETED: colorsMatrix.green.basic,
   EXPOSED: colorsMatrix.grey.basic,
   LOCKED: colorsMatrix.red.basic,
   CANCELED: colorsMatrix.red.basic,
};

const p1PrescriptionStatusIconMap: Record<PrescriptionP1HistoryPrescriptionStatus, IconComponent> = {
   REALIZED: CheckIcon,
   PARTIALLY_COMPLETED: CheckIcon,
   EXPOSED: ClockIcon,
   LOCKED: AlertCircleIcon,
   CANCELED: AlertCircleIcon,
};

export const getP1PrescriptionStatusColor = (status: PrescriptionP1HistoryPrescriptionStatus): string =>
   p1PrescriptionStatusColorMap[status];

export const getP1PrescriptionStatusIcon = (status: PrescriptionP1HistoryPrescriptionStatus): IconComponent =>
   p1PrescriptionStatusIconMap[status];

export const createP1PrescriptionHistoryColumnsWidth = (
   safetyIndicatorsVisible: boolean
): ReturnType<typeof createDynamicColumnsWidth> =>
   createDynamicColumnsWidth({
      medicineName: '100%',
      safetyIndicators: safetyIndicatorsVisible ? '82px' : '0px',
      package: '157px',
      quantity: '72px',
      issuedFrom: '90px',
      expander: '40px',
   });

export const p1PrescriptionHistoryDailyGroupKeyExtractor: TableKeyExtractor<PrescriptionP1HistoryDailyGroup> = (
   dailyGroup
) => String(dailyGroup.issuedOn);
